import { render } from "./ImagePickerWithCropping.vue?vue&type=template&id=8c23a6dc"
import script from "./ImagePickerWithCropping.vue?vue&type=script&lang=js"
export * from "./ImagePickerWithCropping.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__